import { Box, Stack, useMediaQuery, useTheme } from '@mui/material';
import Iconify from 'src/components/iconify';
import { useConversationModalContext } from '../hooks/useConversationModalContext';

export default function ConversationHeader() {
  const {
    state: { size, maximize },
  } = useConversationModalContext();
  const theme = useTheme();
  const isDownLg = useMediaQuery(theme.breakpoints.down('lg'));
  const isDownMd = useMediaQuery(theme.breakpoints.down('md'));

  const isNarrowModal = size.width < 270;
  const boxSize = isNarrowModal ? '30px' : '40px';
  const isMaximizedOnMobile = isDownMd && maximize;

  return isDownLg ? (
    <Box
      className="drag-handle"
      sx={{
        width: boxSize,
        height: boxSize,
        borderRadius: '50%',
        display: isMaximizedOnMobile ? 'none' : 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: theme.palette.background.default,
        cursor: 'move',
        zIndex: '2',
        position: 'absolute',
        top: '8px',
        left: '8px',
        border: '1px solid',
        borderColor: theme.palette.grey[300],
      }}
    >
      <Iconify icon="ic:baseline-drag-indicator" />
    </Box>
  ) : (
    <Stack sx={{ p: 2 }}>
      <Box
        className="drag-handle"
        sx={{
          width: boxSize,
          height: boxSize,
          borderRadius: '50%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: theme.palette.grey[300],
          cursor: 'move',
          zIndex: '2',
        }}
      >
        <Iconify icon="ic:baseline-drag-indicator" />
      </Box>
    </Stack>
  );
}
